import { e as __rest, c as __assign } from '../../../../tslib.es6-80f01feb.js';
import React__default from 'react';

var UserBlockInfoComponent = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest(_a, ["children", "className"]);
    return (React__default.createElement("div", __assign({ className: "user-info-block ".concat(className) }, rest), children));
};
/**
 * @name IdPart
 * @param {string} text - before ID text
 * @param {string} id - user id
 */
var IdPart = function (_a) {
    var text = _a.text, id = _a.id;
    return (React__default.createElement("div", { className: 'user-info-block-r' },
        React__default.createElement("p", { className: 'user-info-block-r-txt', title: "".concat(text, " ").concat(id) },
            text,
            " ",
            id)));
};
/**
 * @name Balance
 * @param {HTMLElement} children
 * @param {number} balance - user balance
 * @param {string} currencyCode - user currency code
 * @param {string} imageSrc - image source path
 * @param {string} alt - image alternative
 * @param {boolean} setWinColor - set win color class for text
 * @param rest - other props
 */
var Balance = function (_a) {
    var children = _a.children, balance = _a.balance, currencyCode = _a.currencyCode, imageSrc = _a.imageSrc, alt = _a.alt, _b = _a.setWinColor, setWinColor = _b === void 0 ? false : _b, rest = __rest(_a, ["children", "balance", "currencyCode", "imageSrc", "alt", "setWinColor"]);
    return (React__default.createElement("div", __assign({ className: 'user-info-block-r' }, rest),
        imageSrc && React__default.createElement("img", { className: 'coin-img', src: imageSrc, alt: alt }),
        React__default.createElement("p", { className: "user-info-block-r-txt-gold ".concat(setWinColor ? 'win-color' : ''), title: "".concat(balance, " ").concat(currencyCode) },
            balance,
            " ",
            currencyCode),
        children));
};
/**
 * @name Deposit
 * @param {function} onDeposit - deposit post message
 */
var Deposit = function (_a) {
    var onDeposit = _a.onDeposit;
    return (React__default.createElement("div", { className: 'add-money-b', onClick: onDeposit },
        React__default.createElement("span", { className: 'c-plus' })));
};
var UserBlockInfo = Object.assign(UserBlockInfoComponent, {
    IdPart: IdPart,
    Balance: Balance,
    Deposit: Deposit,
});

export { UserBlockInfo };
